<template>
  <div class="aside">
    <h3>
      <img src="@/assets/submenu06.png" />
    </h3>
    <el-menu :default-active="activeindex" class="el-menu-vertical-demo" active-text-color="#f00" :router="true">
      <el-menu-item v-for="(item, index) in menu" :key="index" :index="item.path" @click="setactive(item.path)">
        <span slot="title">{{ item.tit }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      menu: [
        { path: '/anquan/case01', tit: '医护人员电子签名解决方案' },
        { path: '/anquan/case02', tit: '患者签名电子认证解决方案' },
        { path: '/anquan/case03', tit: '三级等保解决方案' }
      ],

      activeindex: '/anquan/case01'
    }
  },
  methods: {
    setactive(index) {
      this.activeindex = index
    }
  }
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.aside {
  width: 239px;
  float: left;
  .el-menu {
    border: none;
    background: #f7f7f7;
    .el-menu-item {
      font-size: 16px;
    }
    .el-menu-item.is-active {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
